import { defineComponent } from 'vue';
import Image from '@hems/component/src/image/Image.vue';
import { APP_STORE_TYPE } from '@hems/portal/src/config/constantPortal';
import { useLanguage } from '@hems/util/src/composable/language';
const FACEBOOK_URL = process.env.VUE_APP_FACEBOOK_URL;
const INSTAGRAM_URL = process.env.VUE_APP_INSTAGRAM_URL;
const LINKEDIN_URL = process.env.VUE_APP_LINKEDIN_URL;
const FOOTER_COPYRIGHT_YEAR = 2024;
export default defineComponent({
    name: 'Footer',
    components: { Image },
    emits: ['onOpenMobileAppLinkModal', 'onOpenPrivacyPolicyModal'],
    setup() {
        const { languageCode } = useLanguage();
        return {
            APP_STORE_TYPE,
            languageCode,
            FACEBOOK_URL,
            INSTAGRAM_URL,
            LINKEDIN_URL,
            FOOTER_COPYRIGHT_YEAR,
        };
    },
});
